import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import authenticate from '@/auth/authenticate'
import redirectFormHabeasData from '@/data/redirectFormHabeasData'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/app/forms/HabeasData',
      component: () => import('@/views/app/public/HabeasData'),
      children: [
        {
          path: ':token',
          name: 'PublicHabeasData',
          component: () => import('@/views/app/public/HabeasDataForm'),
          beforeEnter: redirectFormHabeasData
        },
      ],
    },
    {
      path: '/app/forms/HabeasDataNotFound',
      component: () => import('@/views/app/public/HabeasData'),
      children: [
        {
          path: 'FormInvalid',
          name: 'HabeasDataNotFound',
          component: () => import('@/views/app/public/HabeasDataNotFound'),
        },
      ],
    },
    {
      path: '/app/sessions',
      component: () => import('@/views/app/sessions/Sessions'),

      children: [
        {
          path: 'sign-in',
          name: 'login',
          component: () => import('@/views/app/sessions/SignIn'),
        },
        {
          path: 'RememberPassword',
          name: 'RememberPassword',
          component: () => import('@/views/app/sessions/RememberPassword'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/app/Index'),
      beforeEnter: authenticate,
      redirect: '/app/dashboard/statistics',

      children: [
        {
          path: '/app/dashboard',
          component: () => import('@/views/app/dashboard/Index'),

          children: [
            {
              path: 'statistics',
              name: 'statistics',
              meta: {
                breadcrumb: [{ name: 'Dashboard' }, { name: 'Statistics' }],
              },
              component: () => import('@/views/app/dashboard/Statistics'),
            },
          ],
        },
        {
          path: '/app/administration',
          component: () => import('@/views/app/administration/Index'),
          children: [
            {
              path: 'clientsConfig',
              name: 'clientsConfig',
              meta: {
                breadcrumb: [{ name: 'ClientsConfig' }, { name: 'clientsConfig' }],
                requiresPermission: 'Configuración Clientes',
              },
              component: () => import('@/views/app/administration/ClientsConfig'),
            },
            {
              path: 'emisorConfig',
              name: 'emisorConfig',
              meta: {
                breadcrumb: [{ name: 'EmisorConfig' }, { name: 'emisorConfig' }],
                requiresPermission: 'Configuración Emisor',
              },
              component: () => import('@/views/app/administration/EmisorConfig'),
            },
            {
              path: 'numerationsConfig',
              name: 'numerationsConfig',
              meta: {
                breadcrumb: [{ name: 'NumerationsConfig' }, { name: 'numerationsConfig' }],
                requiresPermission: 'Consultar Resoluciones',
              },
              component: () => import('@/views/app/administration/NumerationsConfig'),
            },
            {
              path: 'tefConfig',
              name: 'tefConfig',
              meta: {
                breadcrumb: [{ name: 'TefConfig' }, { name: 'tefConfig' }],
                requiresPermission: 'Configuración TEF',
              },
              component: () => import('@/views/app/administration/components/tef/TefConfig'),
            },
            {
              path: 'tefConfigTerminales',
              name: 'tefConfigTerminales',
              meta: {
                breadcrumb: [{ name: 'TefConfigTerminales' }, { name: 'tefConfigTerminales' }],
              },
              component: () => import('@/views/app/administration/components/tef/TefConfigTerminales'),
            },
            {
              path: 'loyaltyPuntosColombia',
              name: 'loyaltyPuntosColombia',
              meta: {
                breadcrumb: [{ name: 'LoyaltyPuntosColombia' }, { name: 'loyaltyPuntosColombia' }],
                requiresPermission: 'Configuración Puntos Colombia',
              },
              component: () => import('@/views/app/administration/components/LoyaltyConfig/LoyaltyPuntosColombia'),
            },
            {
              path: 'loyaltyTerminalesPuntosColombia',
              name: 'loyaltyTerminalesPuntosColombia',
              meta: {
                breadcrumb: [{ name: 'LoyaltyTerminalesPuntosColombia' }, { name: 'loyaltyTerminalesPuntosColombia' }],
              },
              component: () => import('@/views/app/administration/components/LoyaltyConfig/LoyaltyTerminalesPuntosColombia'),
            },
            {
              path: 'configuracionAlianza',
              name: 'configuracionAlianza',
              meta: {
                breadcrumb: [{ name: 'ConfiguracionAlianza' }, { name: 'configuracionAlianza' }],
                requiresPermission: 'Configuración Alianzas',
              },
              component: () => import('@/views/app/administration/components/alianzas/ConfiguracionAlianza'),
            },
            {
              path: 'userConfig',
              name: 'userConfig',
              meta: {
                breadcrumb: [{ name: 'UserConfig' }, { name: 'userConfig' }],
                requiresPermission: 'Configuración Usuarios',
              },
              component: () => import('@/views/app/administration/UserConfig'),
            },
            {
              path: 'confHiopos',
              name: 'confHiopos',
              meta: {
                breadcrumb: [{ name: 'ConfHiopos' }, { name: 'confHiopos' }],
                requiresPermission: 'Config Hiopos Reports',
              },
              component: () => import('@/views/app/administration/ConfHiopos'),
            },
            {
              path: 'loadXML',
              name: 'loadXML',
              meta: {
                breadcrumb: [{ name: 'LoadXML' }, { name: 'loadXML' }],
                requiresPermission: 'Procesar XMLS',
              },
              component: () => import('@/views/app/administration/LoadXML'),
            },
            {
              path: 'downloadXML',
              name: 'downloadXML',
              meta: {
                breadcrumb: [{ name: 'DownloadXML' }, { name: 'downloadXML' }],
                requiresPermission: 'Descarga XMLS',
              },
              component: () => import('@/views/app/administration/DownloadXML'),
            },
            {
              path: 'massiveCreditNoteProcess',
              name: 'massiveCreditNoteProcess',
              meta: {
                breadcrumb: [{ name: 'MassiveCreditNoteProcess' }, { name: 'massiveCreditNoteProcess' }],
                requiresPermission: 'Generación Masiva de NC',
              },
              component: () => import('@/views/app/administration/MassiveCreditNoteProcess'),
            },
            {
              path: 'RememberPassword',
              name: 'RememberPassword',
              meta: {
                breadcrumb: [{ name: 'RememberPassword' }, { name: 'RememberPassword' }],
              },
              component: () => import('@/views/app/sessions/RememberPassword'),
            },
            {
              path: 'Logs',
              name: 'Logs',
              meta: {
                breadcrumb: [{ name: 'Logs' }, { name: 'Logs' }],
                requiresPermission: 'Logs',
              },
              component: () => import('@/views/app/administration/Logs'),
            },
            {
              path: 'deleteTransactions',
              name: 'deleteTransactions',
              meta: {
                breadcrumb: [{ name: 'deleteTransactions' }, { name: 'deleteTransactions' }],
                requiresPermission: 'Eliminar Transacciones',
              },
              component: () => import('@/views/app/administration/DeleteTransactions'),
            },
            {
              path: 'updateStatusTransactions',
              name: 'updateStatusTransactions',
              meta: {
                breadcrumb: [{ name: 'updateStatusTransactions' }, { name: 'updateStatusTransactions' }],
                requiresPermission: 'Actualizar Estado Transacciones',
              },
              component: () => import('@/views/app/administration/UpdateStatusTransactions'),
            },
          ],
        },
        {
          path: '/app/invoices',
          component: () => import('@/views/app/invoices/Index'),
          children: [
            {
              path: 'reportInvoices',
              name: 'reportInvoices',
              meta: {
                breadcrumb: [{ name: 'ReportInvoices' }, { name: 'reportInvoices' }],
                requiresPermission: 'Reporte Facturas',
              },
              component: () => import('@/views/app/invoices/ReportInvoices'),
            },
            {
              path: 'alertConfigs',
              name: 'alertConfigs',
              meta: {
                breadcrumb: [{ name: 'AlertConfigs' }, { name: 'alertConfigs' }],
                requiresPermission: 'Gestión Facturación',
              },
              component: () => import('@/views/app/invoices/AlertConfigs'),
            },

            {
              path: 'HabeasDataManagement',
              name: 'HabeasDataManagement',
              meta: {
                breadcrumb: [{ name: 'HabeasDataManagement' }, { name: 'HabeasDataManagement' }],
              },
              component: () => import('@/views/app/invoices/HabeasDataManagement'),
            },
          ],
        },
        {
          path: '/app/user/roles-permisos',
          name: 'RolesAndPermissions',
          meta: {
            requiresPermission: 'Roles Y Permisos',
          },
          component: () => import('@/views/app/user/RolesAndPermissions'),
        },
        {
          path: '/app/error/forbidden',
          name: 'forbidden',
          component: () => import('@/views/app/error/Forbidden.vue'),
        },
        {
          path: '/app/taxreports',
          component: () => import('@/views/app/taxreports/ExogenaInformation'),
          children: [
            {
              path: 'exogenaInformation',
              name: 'exogenaInformation',
              meta: {
                breadcrumb: [{ name: 'exogenaInformation' }, { name: 'exogenaInformation' }],
              },
              component: () => import('@/views/app/taxreports/ExogenaInformation'),
            },
          ],
        },
      ],
    },

  ],
})

router.beforeEach((to, from, next) => {
  if (to.path) {
    store.dispatch('changeThemeLoadingState', true)
  }

  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const required = to.meta.requiresPermission

  if (!required) {
    return next()
  }

  const hasPermission = Array.isArray(required)
    ? required.some(p => permissions.includes(p))
    : permissions.includes(required)

  if (!hasPermission) {
    return next('/app/error/forbidden')
  }

  next()
})

router.afterEach(() => {
  // Remove initial loading
  // const gullPreLoading = document.getElementById("loading_wrap");
  // if (gullPreLoading) {
  //   gullPreLoading.style.display = "none";
  // }
  // Complete the animation of the route progress bar.
  setTimeout(() => store.dispatch('changeThemeLoadingState', false), 500)
  // NProgress.done();
  // if (isMobile) {
  // if (window.innerWidth <= 1200) {
  //   // console.log("mobile");
  //   store.dispatch("changeSidebarProperties");
  //   if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
  //     store.dispatch("changeSecondarySidebarProperties");
  //   }
  //   if (store.getters.getCompactSideBarToggleProperties.isSideNavOpen) {
  //     store.dispatch("changeCompactSidebarProperties");
  //   }
  // } else {
  //   if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
  //     store.dispatch("changeSecondarySidebarProperties");
  //   }
  //   // store.state.sidebarToggleProperties.isSecondarySideNavOpen = false;
  // }
})

export default router
